import React, { useEffect, useState } from 'react';
import { IModelSelection } from './IModelSelection';
import { SelectItem } from '../../../../types';
import { filterSelectItems } from '../../../../utils';
import { LoadingPage } from '../../../Shared';
import { IModelsApi } from '../../../../apis';

export interface IModelSelectionContainerProps {
  projectId: string;
  selected?: string;
  setIModelId: (iModel: string) => void;
}

export function IModelSelectionContainer({
  projectId,
  selected,
  setIModelId,
}: IModelSelectionContainerProps): JSX.Element {
  const [items, setItems] = useState<SelectItem[]>([]);
  const [displayedItems, setDisplayedItems] = useState<SelectItem[]>([]);
  const [filter, setFilter] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const init = async () => {
    const iModels: SelectItem[] = (
      await IModelsApi.fetchIModels(projectId)
    ).map(iModel => ({
      value: iModel.instanceId,
      text: iModel.name,
      onClick: () => setIModelId(iModel.instanceId),
    }));

    selected ?? setIModelId(iModels[0]?.value);
    setItems(iModels);
    setDisplayedItems(iModels);
    setLoading(false);
  };

  useEffect(() => {
    init().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    setDisplayedItems(filterSelectItems(items, filter));
  }, [filter]);

  const onSearch = async (input: string = '') => {
    setFilter(input);
  };

  const onClear = async () => {
    setFilter('');
  };

  const onChange = async (input: string = '') => {
    setFilter(input);
  };

  if (loading) {
    return <LoadingPage subtext='Fetching iModels...' fullscreen />;
  }

  return (
    <IModelSelection
      items={displayedItems}
      selected={selected}
      onSearch={onSearch}
      onClear={onClear}
      onChange={onChange}
    />
  );
}
